module.exports = __webpack_public_path__ + "media/media/shop/item-2-7607e67921b6d22b6af38a0d657aa682.png";